import { useGlobalConfig } from '../hooks';
import type { OddsType } from '../types';

/**
 * Finds the greatest common divisor using binary GCD algorithm.
 * @param a First number
 * @param b Second number
 * @returns GCD of a and b.
 */
const gcd = (
    a: number,
    b: number
): number => {
    /* GCD(0, b) == b; GCD(a, 0) == a,
        GCD(0, 0) == 0 */
    if (a == 0) return b;
    if (b == 0) return a;

    /*Finding K, where K is the
        greatest power of 2
        that divides both a and b. */
    let k: number;
    for (k = 0; ((a | b) & 1) == 0; ++k) {
        a >>= 1;
        b >>= 1;
    }

    /* Dividing a by 2 until a becomes odd */
    while ((a & 1) == 0) a >>= 1;

    /* From here on, 'a' is always odd. */
    do {
        /* If b is even, remove all factor of 2 in b */
        while ((b & 1) == 0) b >>= 1;

        /* Now a and b are both odd.
            Swap if necessary so a <= b,
            then set b = b - a (which is even).*/
        if (a > b) {
            const t = a;
            a = b;
            b = t;
        }

        b = b - a;
    } while (b != 0);

    /* restore common factors of 2 */
    return a << k;
}



// TODO:
// one copy of the logic is here: Uni.UI\Frontend\src\Shared\Infrastructure\Utils.ts
// just for legacy
// BUT need to sync/actualize all changes

const displayCoefValue = (
    coefValue: number,
    oddsType?: OddsType
): string => {
    const { $oddsType } = useGlobalConfig();

    switch (oddsType || $oddsType) {
        case 'American':
            if (coefValue > 1 && coefValue < 2)
                return '-' + Math.round(100 / (coefValue - 1)).toFixed(0);
            if (coefValue === 2) return 'Even';
            if (coefValue > 2)
                return '+' + Math.round(100 * (coefValue - 1)).toFixed(0);
            return '-';
        case 'British':
            const numerator = Math.round(100 * (coefValue - 1));
            const denominator = 100;
            const hcf = gcd(numerator, denominator);
            return (
                Math.floor(numerator / hcf) +
                '/' +
                Math.floor(denominator / hcf)
            );
        case 'HongKong':
            return (coefValue - 1).toFixed(2);
        case 'Indonesian':
            if (coefValue > 1 && coefValue < 2)
                return '-' + Math.round(1 / (coefValue - 1)).toFixed(2);
            if (coefValue === 2) return 'Even';
            if (coefValue > 2)
                return '+' + Math.round(coefValue - 1).toFixed(2);
            return '-';
        case 'Malaysian':
            if (coefValue > 1 && coefValue < 2)
                return '+' + Math.round(1 / (coefValue - 1)).toFixed(2);
            if (coefValue === 2) return 'Even';
            if (coefValue > 2)
                return '-' + Math.round(coefValue - 1).toFixed(2);
            return '-';
        case 'European':
        default:
            return coefValue.toFixed(2);
    }
}

export {
    displayCoefValue,
}

